import { useEffect, useRef } from "react"

export function useWindowEvent<E extends keyof WindowEventMap>(
  type: E,
  handler: (e: WindowEventMap[E]) => void
) {
  const handlerRef = useRef(handler)

  // Set the current handler
  handlerRef.current = handler

  // Add the event listener
  useEffect(() => {
    const trueHandler = (e: any) => {
      handlerRef.current(e)
    }
    window.addEventListener(type, trueHandler)
    return () => {
      window.removeEventListener(type, trueHandler)
    }
  }, [type])
}
